(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function processInstagramEmbeds(container) {
      var root = container || document;
      var embed = root.querySelector('.instagram-feed__embed');

      if (!embed) {
        return;
      }

      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
        return;
      }

      if (document.querySelector('script[src*="instagram.com/embed.js"]')) {
        return;
      }

      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.instagram.com/embed.js';
      script.onload = function () {
        if (window.instgrm && window.instgrm.Embeds) {
          window.instgrm.Embeds.process();
        }
      };
      document.body.appendChild(script);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        processInstagramEmbeds(document);
      });
    } else {
      processInstagramEmbeds(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      processInstagramEmbeds(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitrine-cases"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vitrine-cases')) {
    customElements.define(
      'vitrine-cases',
      class VitrineCases extends HTMLElement {
        connectedCallback() {
          this.state = { mood: 'all', length: null };
          this.cases = Array.from(this.querySelectorAll('.vc__case'));
          this.countEl = this.querySelector('[data-count]');
          this.emptyEl = this.querySelector('[data-empty]');

          this.querySelectorAll('.vc__tick').forEach((tick) => {
            const n = this.cases.filter((c) => c.dataset.length === tick.dataset.value).length;
            if (n === 0) tick.disabled = true;
          });

          this.addEventListener('click', (event) => {
            const filter = event.target.closest('[data-filter]');
            if (filter && !filter.disabled) return this.onFilter(filter);
            const size = event.target.closest('.vc__size');
            if (size && !size.disabled) return this.addToCart(size);
            if (event.target.closest('[data-reset]')) return this.reset();
          });

          this.update();
        }

        onFilter(button) {
          const type = button.dataset.filter;
          let value = button.dataset.value;
          if (type === 'length' && this.state.length === value) value = null;
          this.state[type] = value;
          this.querySelectorAll(`[data-filter="${type}"]`).forEach((b) => {
            b.setAttribute('aria-pressed', String(b.dataset.value === value));
          });
          this.update();
        }

        reset() {
          this.state = { mood: 'all', length: null };
          this.querySelectorAll('[data-filter]').forEach((b) => {
            b.setAttribute('aria-pressed', String(b.dataset.filter === 'mood' && b.dataset.value === 'all'));
          });
          this.update();
        }

        update() {
          let shown = 0;
          this.cases.forEach((c) => {
            const ok =
              (this.state.mood === 'all' || c.dataset.mood === this.state.mood) &&
              (!this.state.length || c.dataset.length === this.state.length);
            c.hidden = !ok;
            if (ok) shown += 1;
          });
          if (this.countEl) this.countEl.textContent = shown === 1 ? '1 set' : `${shown} sets`;
          if (this.emptyEl) this.emptyEl.hidden = shown !== 0;
        }

        addToCart(button) {
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const body = new FormData();
          body.append('id', button.dataset.variant);
          body.append('quantity', 1);
          if (cart) {
            body.append('sections', cart.getSectionsToRender().map((s) => s.id));
            body.append('sections_url', window.location.pathname);
            cart.setActiveElement(button);
          }
          button.classList.add('is-loading');
          fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body,
          })
            .then((r) => r.json())
            .then((response) => {
              if (response.status) {
                button.disabled = true;
                return;
              }
              if (!cart) {
                window.location = window.routes.cart_url;
                return;
              }
              cart.renderContents(response);
              cart.classList.remove('is-empty');
              button.classList.add('is-added');
              setTimeout(() => button.classList.remove('is-added'), 1600);
            })
            .catch((e) => console.error(e))
            .finally(() => button.classList.remove('is-loading'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
